import React from 'react'
import { height, background, mountAnim } from '../anim';
import { motion } from 'framer-motion';

export default function Index() {
    return (
        <motion.div className="top-0 left-0 fixed z-[2] h-screen flex transition-all duration-1000 pointer-events-none">
            {
                [...Array(5)].map((_, index) => {
                    return (
                        <motion.div
                            key={index}
                            variants={height}
                            {...mountAnim}
                            custom={4 - index}
                            className="bg-smoke w-[20vw] h-full">
                        </motion.div>
                    );
                })
            }
            <motion.div
                variants={background}
                {...mountAnim}
                className="w-full h-full absolute bg-smoke">
            </motion.div>
        </motion.div>
    );
}
